declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

const PIXEL_ID = '926479933292182'
let initialized = false

export function initMetaPixel() {
  if (initialized) return
  if (typeof window === 'undefined') return

  // Standard Facebook Pixel initialization script
  const f: any = window
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s)
  }

  window.fbq('init', PIXEL_ID)
  initialized = true
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(data?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', data)
  }
}
